import { render, staticRenderFns } from "./PromoActions.vue?vue&type=template&id=94e57502&scoped=true&"
import script from "./PromoActions.vue?vue&type=script&lang=js&"
export * from "./PromoActions.vue?vue&type=script&lang=js&"
import style0 from "./PromoActions.vue?vue&type=style&index=0&id=94e57502&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e57502",
  null
  
)

export default component.exports